// @flow
import React from "react";
import "./couponFree.scss";
import Form from "../../../components/form";
import formSchema from "./schema";

class CouponFree extends Form {
  constructor(props: any) {
    super(props, formSchema);
    this.state = {
      ...this.state
    };
  }

  doPay() {
    const { onPay } = this.props;
    const values = this.getValues();

    this.validate().then(
      () => onPay(values),
      () => null
    );
  }

  render() {
    return (
      <div className="coupon-free">
        <span className="column is-12 coupon-free-notification">
          <span className="coupon-free-notification-title">Seja bem-vindo!</span>
          <span className="coupon-free-notification-content">
            Seu cupom garante acesso gratuito ao Aprova Total e você já pode começar a usar a plataforma imediatamente!
          </span>
        </span>
      </div>
    );
  }
}

CouponFree.displayName = "CouponFree";

export default CouponFree;
